import { useEffect, useState } from 'react';
import { Layout } from '@/components/Layout';
import { centralApi, DemoBanner } from '@/services/centralApi';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const timeAgo = (iso) => {
  if (!iso) return '';
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return 'agora mesmo';
  if (diff < 3600) return `${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} h`;
  return `${Math.floor(diff / 86400)} d`;
};

export default function CentralAguardando() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [waConnected, setWaConnected] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const [d, s] = await Promise.all([
          centralApi.getWaiting(),
          centralApi.getWaSettings().catch(() => ({})),
        ]);
        setItems(d.items || []);
        setWaConnected(!!s?.connected);
      } finally { setLoading(false); }
    })();
  }, []);

  const atender = async (id) => {
    try { await centralApi.assumeConversation(id); } catch (e) {}
    navigate(`/central/conversas?id=${id}`);
  };

  return (
    <Layout>
    <div className="space-y-4" data-testid="central-aguardando">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold">Aguardando Atendimento</h1>
        <p className="text-sm text-muted-foreground">Clientes que pediram para falar com uma pessoa</p>
      </div>
      <DemoBanner when={!waConnected} />

      {loading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : items.length === 0 ? (
        <Card className="p-8 text-center text-sm text-muted-foreground border-dashed">
          Ninguém aguardando no momento.
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map(c => (
            <Card key={c.id} className="p-4 border-amber-500/50 bg-amber-500/5" data-testid={`aguardando-${c.id}`}>
              <div className="flex items-start gap-3 mb-3">
                <div className="h-9 w-9 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0">
                  <AlertTriangle className="h-4 w-4 text-amber-600" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs uppercase font-semibold text-amber-600">Aguardando atendente</p>
                  <p className="font-semibold truncate">{c.customer_name || 'Novo contato'}</p>
                  <p className="text-xs text-muted-foreground">+{c.phone}</p>
                </div>
              </div>
              <p className="text-sm mb-3 line-clamp-2">"{c.last_message || '—'}"</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-muted-foreground">Aguardando há {timeAgo(c.last_message_at)}</span>
                <Button size="sm" className="bg-amber-500 hover:bg-amber-500/90" onClick={() => atender(c.id)} data-testid={`btn-atender-${c.id}`}>
                  Atender
                </Button>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
    </Layout>
  );
}
